import { render } from "./Serial.vue?vue&type=template&id=1810095b&scoped=true"
import script from "./Serial.vue?vue&type=script&lang=js"
export * from "./Serial.vue?vue&type=script&lang=js"

import "./Serial.vue?vue&type=style&index=0&id=1810095b&lang=scss&scoped=true"

import exportComponent from "F:\\work\\1\\s\\vue-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1810095b"]])

export default __exports__